import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';
import { siteData } from '@/mocks/siteData';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-gamepad-line text-xl text-primary-400"></i>
              </div>
              <span className="text-lg font-heading text-background-50">黄油游戏指南</span>
            </div>
            <p className="text-sm text-background-50/70 leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                  {t('nav.about')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">{t('footer.categories')}</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">{t('footer.contact')}</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-background-50/70">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-mail-line text-xs"></i>
                </div>
                <span>{siteData.email}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-50/70">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-xs"></i>
                </div>
                <span>{siteData.address}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-50/70">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-phone-line text-xs"></i>
                </div>
                <span>{siteData.phone}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/15">
        <div className="w-full px-4 md:px-6 py-5">
          <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/50">{t('footer.copyright')}</p>
            <div className="flex items-center gap-4">
              <a href={siteData.socialLinks.weibo} target="_blank" rel="nofollow noopener" className="text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-weibo-line text-sm"></i>
                </div>
              </a>
              <a href={siteData.socialLinks.bilibili} target="_blank" rel="nofollow noopener" className="text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-bilibili-line text-sm"></i>
                </div>
              </a>
              <span className="text-xs text-background-50/30">
                微信：{siteData.socialLinks.wechat}
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}